.trigger {
	display: inline-flex;
	align-items: center;
	justify-content: center;
	cursor: default;
	position: relative;
	height: 20px;
}

.loaderDots {
	display: inline-flex;
	gap: 3px;
	align-items: center;
}

.loaderDots span {
	width: 4px;
	height: 4px;
	border-radius: 50%;
	background: var(--color-gray-6);
	animation: dotPulse 1s infinite ease-in-out;
}

.loaderDots span:nth-child(2) {
	animation-delay: 0.15s;
}
.loaderDots span:nth-child(3) {
	animation-delay: 0.3s;
}

@keyframes dotPulse {
	0%,
	80%,
	100% {
		opacity: 0.3;
		transform: scale(0.8);
	}
	40% {
		opacity: 1;
		transform: scale(1);
	}
}

.checkIcon {
	display: inline-flex;
	color: var(--color-gray-6);
}

.popover {
	position: fixed;
	z-index: 1000;
	background: rgba(255, 255, 255, 0.6);
	backdrop-filter: blur(8px);
	border: 1px solid var(--color-gray-3);
	border-radius: 6px;
	padding: 8px;
	box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
	min-width: 187px;
	transition: opacity 300ms;
}

.popoverHidden {
	opacity: 0;
	pointer-events: none;
}

.stack {
	display: flex;
	flex-direction: column;
	gap: 3px;
}

.row {
	display: flex;
	gap: 16px;
	flex-wrap: nowrap;
	justify-content: space-between;
}

.label {
	font-size: 12px;
}

.mono {
	font-family: Consolas, monospace;
	font-size: 12px;
	min-width: 36px;
	text-align: right;
}

.dimmed {
	color: var(--color-dimmed);
}
.blue {
	color: var(--color-primary);
}
.green {
	color: var(--color-green);
}
.bold {
	font-weight: 500;
}

.divider {
	border: none;
	border-top: 1px solid var(--color-gray-3);
	margin: 4px 0;
}
